<template>
  <div class="competitor">
    <h1>{{competitor.firstname}} {{competitor.lastname}}</h1>
    <div class="meta">
      <p v-if="competitor.club"><b>Primary Club: </b>{{competitor.club.name}}</p>
      <p v-if="competitor.club2"><b>Secondary Club: </b> {{ competitor.club2.name }}</p>
      <p v-if="competitor.rating"><b>Rating: </b>{{competitor.rating}}</p>
      <p v-if="competitor.birthyear && (me.role == 'coach' || isMe)"><b>Birth year: </b>{{ competitor.birthyear }}</p>
      <p v-if="competitor.email && (me.role == 'coach' || isMe)"><b>email: </b><a :href="'mailto:'+competitor.email">{{ competitor.email }}</a></p>
    </div>
    <ul class="tab tab-block" v-if="(me.role == 'coach' || isMe)">
      <li :class="classTabClass"><a href="#classes" v-on:click.prevent="toggleTabs">Classes</a></li>
      <li :class="scoresClass"><a href="#scores" v-on:click.prevent="toggleTabs">Scores</a></li>
    </ul>
    <div v-if="showClassesTab" class="wrapper">
      <div v-if="me.role == 'coach' || isMe">
        <h2>Class registrations</h2>
        <ul class="classes" v-if="classes && classes.length > 0">
          <li v-for="klass in classes">
            <classComponent :smallerHeader="true" :passedEvent="klass" :passedMe="me" />
          </li>
        </ul>
        <p v-else>Not registered for anything.</p>
      </div>
    </div>
    <div v-if="showScoresTab" class="wrapper">
      <div>
        <svg width="900" height="400" viewBox="0,0,900,400" v-if="scores && scores.length > 0"></svg>
      </div>
      <table class="scores" v-if="(scores && scores.length > 0) && me.role != 'coach'">
        <tr>
          <th>Event</th>
          <th>Score</th>
          <th>Indicator</th>
          <th></th>
        </tr>
        <tr v-for="score in scores">
          <td><router-link :to="'/event/'+score.event.uuid">{{ score.event.name }}</router-link></td>
          <td>{{score.onescore}} - {{score.twoscore}}</td>
          <td>{{score.onescore-score.twoscore}}</td>
          <td><router-link :to="'/bout/'+score.uuid">View</router-link></td>
        </tr>
      </table>
      <table class="table" v-else-if="(scores && scores.length > 0)">
        <tr>
          <th>Fencer two</th>
          <th>{{competitor.firstname}}'s score</th>
          <th>Competitor score</th>
          <th>Event</th>
        </tr>
        <tr v-for="score in scores">
          <td>{{score.competitor.firstname}} {{score.competitor.lastname}}</td>
          <td>{{score.myscore}}</td>
          <td>{{score.compscore}}</td>
          <td>{{score.event.name}}</td>
        </tr>
      </table>
      <div v-else>No scores to show yet</div>
    </div>
  </div>
</template>

<script>
import config from "../config"
import classComponent from "./Class"

export default {
  name: 'competitor',
  components : { classComponent },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  created () {
    this.getData()
    .then(e => {
      if(!this.isMe && this.me.role != "coach" && this.scores && this.scores.length > 0){
        this.showClassesTab = false
        this.classTabClass = "tab-item"
        this.showScoresTab = true
        this.scoresClass = "tab-item active"
        if(!this.graphSetup) {
          setTimeout(() => {
            this.setupGraph()
          },500)
        }
      } else if(!this.isMe && this.me.role != "coach") {
        this.showClassesTab = true
        this.classTabClass = "tab-item active"
        this.showScoresTab = false
        this.scoresClass = "tab-item"
      }
    })
  },
  methods : {
    setData(d, d2, d3, d4){
      this.competitor = d
      this.me = d2
      if(this.competitor.firstname == this.me.firstname && this.competitor.lastname == this.me.lastname) this.isMe = true
      if(this.me.role == "coach" || this.isMe) this.classes = d3
      else this.scores = d3
      if(d4) {
        this.scores = d4
        this.scores.forEach(score => {
          if(score.fencerone[0].firstname !== this.competitor.firstname && score.fencerone[0].lastname !== this.competitor.lastname){
            score.competitor = score.fencerone[0]
            score.compscore = score.onescore
            score.myscore = score.twoscore
          } else {
            score.competitor = score.fencertwo[0]
            score.compscore = score.twoscore
            score.myscore = score.onescore
          }
        })
      }
    },
    getData(){
      return new Promise((resolve, reject) => {
        fetch(config.baseUrl+"user/fencers/"+this.$route.params.uuid,{
          credentials : "include"
        })
        .then(e => {
          return e.json()
        }).then(j => {
          fetch(config.baseUrl+"user/me",{
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j2 => {
            if(j2.role == "coach" || j.id == j2.id){
              fetch(config.baseUrl+"events/classes/fencer/"+j.id+"/all/", {
                credentials : "include"
              }).then(e => {
                return e.json()
              }).then(j3 => {
                fetch(config.baseUrl+"scores/fencer/"+j.id, {
                  credentials : "include"
                }).then(e => {
                  return e.json()
                }).then(j4 => {
                  this.setData(j, j2, j3, j4)
                  resolve()
                })
              })
            } else {
              fetch(config.baseUrl+"scores/mine/fencer/"+j.id, {
                credentials : "include"
              }).then(e => {
                return e.json()
              }).then(j3 => {
                this.setData(j, j2, j3)
                resolve()
              })
            }
          })
        })
      })
    },
    toggleTabs(e){
      let target = e.target.getAttribute("href").replace("#", "")

      if(target == "scores"){
        this.showClassesTab = false
        this.classTabClass = "tab-item"
        this.showScoresTab = true
        this.scoresClass = "tab-item active"
        if(!this.graphSetup) {
          setTimeout(() => {
            this.setupGraph()
          },100)
        }
      } else {
        this.showScoresTab = false
        this.scoresClass = "tab-item"
        this.showClassesTab = true
        this.classTabClass = "tab-item active"
      }
    },
    setupGraph(){
      var svg = d3.select("svg"),
          margin = {top: 20, right: 20, bottom: 30, left: 40},
          width = +svg.attr("width") - margin.left - margin.right,
          height = +svg.attr("height") - margin.top - margin.bottom;

      var parseTime = d3.timeFormat("%Y-%m-%d"),
          bisectDate = d3.bisector(function(d) { return d.event.date; }).left;

      var x = d3.scaleTime().range([0, width]);
      var y = d3.scaleLinear().range([height, 0]);

      this.graphUrl = this.me.role == "coach" ? "scores/fencer/"+this.competitor.id : "scores/mine/fencer/"+this.me.id
      d3.json(config.baseUrl+this.graphUrl, function(error, data) {
        data.reverse()
        if (error) throw error;

        var line = d3.line(data)
            .x(function(d) { return x(d.year); })
            .y(function(d) { return y(d.indicator); });

        var g = svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");


        data.forEach(function(d,i) {
          d.year = i;
          d.indicator = d.onescore - d.twoscore;
        });

        x.domain(d3.extent(data, function(d) { return d.year; }));
        y.domain([d3.min(data, function(d) { return d.indicator; }), d3.max(data, function(d) { return d.indicator; })]);

        g.append("g")
            .attr("class", "axis axis--x")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x));

        g.append("g")
            .attr("class", "axis axis--y")
            .call(d3.axisLeft(y).ticks(6).tickFormat(function(d) { return parseInt(d); }))
          .append("text")
            .attr("class", "axis-title")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .attr("fill", "#5D6971")
            .text("Indicator");

        g.append("path")
            .attr("class", "line")
            .attr("stroke", "#807fe2")
            .attr("fill", "transparent")
            .attr("d", line(data));
      })
    }
  },
  data () {
    return {
      competitor : {},
      scores : [],
      me : {},
      isMe : false,
      showScoresTab : false,
      showClassesTab : true,
      scoresClass : "tab-item",
      classTabClass : "tab-item active",
      graphUrl : ""
    }
  },
}
</script>

<style lang="scss">
  .competitor {
    .classes {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    svg {
      width: 100%;
      height: auto;
    }
    .meta {
      p {
        margin: 0;
      }
    }
    .wrapper {
      margin-top: 40px;
    }
  }
</style>
